module.exports = __webpack_public_path__ + "img/202.a7c6dc07.png";